import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { supabase } from "../services/supabase";
import { useRole } from "../context/RoleContext";
import useAutoRefresh from "../hooks/useAutoRefresh";

const Sidebar = () => {
  const { currentMode } = useRole();
  const navigate = useNavigate();

  const isAdmin = currentMode === "admin";

  const [supportCounts, setSupportCounts] = useState({
    open: 0,
    pending: 0,
  });

  useAutoRefresh(() => {
loadSupportCounts();
}, 10000);

  /* =========================
     LOAD SUPPORT COUNTS
  ========================= */
  const loadSupportCounts = async () => {
    const { data } = await supabase
      .from("support_tickets")
      .select("status");

    if (!data) return;

    const open = data.filter((t) => t.status === "open").length;
    const pending = data.filter((t) => t.status === "pending").length;

    setSupportCounts({ open, pending });
  };

  /* =========================
     INIT + REALTIME
  ========================= */
  useEffect(() => {
    loadSupportCounts();

    const channel = supabase
      .channel("support-sidebar")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "support_tickets",
        },
        () => loadSupportCounts()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const menuItemsAdmin = [
    { path: "/dashboard", label: "Dashboard" },
    { path: "/rides", label: "Courses" },
    { path: "/drivers", label: "Chauffeurs" },
    { path: "/clients", label: "Clients" },
    { path: "/zones", label: "Zones" },
    { path: "/dispatchers", label: "Répartiteurs" },
    { path: "/support", label: "Support", support: true },
  ];

  const menuItemsDispatcher = [
    { path: "/dashboard", label: "Dashboard" },
    { path: "/rides", label: "Courses" },
    { path: "/drivers", label: "Chauffeurs" },
    { path: "/clients", label: "Clients" },
    { path: "/support", label: "Support", support: true },
  ];

  const items = isAdmin ? menuItemsAdmin : menuItemsDispatcher;

  return (
    <aside className="sidebar">
      <div className="sidebar-logo" onClick={() => navigate("/dashboard")}>
                <div className="sidebar-imglogo">
                <img src="/Bel_taxi_logo.png" alt="Logo" />
                </div>
          Bel Taxi Admin
      </div>

      <nav>
        <ul className="sidebar-menu">
          {items.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }
              >
                <span className="sidebar-label">
                  {item.label}

                  {/* 🔔 BADGE SUPPORT */}
                  {item.support && (
                    <>
                      {supportCounts.open > 0 && (
                        <span className="badge badge-open">
                          {supportCounts.open}
                        </span>
                      )}

                      {supportCounts.pending > 0 && (
                        <span className="badge badge-pending">
                          {supportCounts.pending}
                        </span>
                      )}
                    </>
                  )}
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;


